import { $config } from '@client/core/atoms/config.js';
import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';
import {
  UNLEASH_FEATURE_NAME,
  Vertical
} from '@schibsted-nmp/advertising-shared';

export const isFinnMobilityPulseAds = () =>
  $config.get()?.vertical === Vertical.Mobility &&
  isFeatureEnabled(UNLEASH_FEATURE_NAME.enablePulseEventsForAds);
